module.exports = __webpack_public_path__ + "img/item-4.08c6b08c.png";